export const SWEEPSTAKES_STEPS = ["intro", "quiz", "email", "success"] as const;

export type SweepstakesStep = (typeof SWEEPSTAKES_STEPS)[number];

export const nextStep = (step: SweepstakesStep): SweepstakesStep | null =>
  SWEEPSTAKES_STEPS[SWEEPSTAKES_STEPS.indexOf(step) + 1] ?? null;
